import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Reveal } from './Reveal';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="px-5 py-24 lg:px-8 lg:py-32" data-id="element-34" data-mp="1gjby3hs5c4zk">
      <div className="mx-auto grid max-w-shell gap-12 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-35" data-mp="1glpt5qmtth74">
        <Reveal data-id="element-36" data-mp="249zkf82t6x5n">
          <h2 className="text-[30px] font-extrabold uppercase leading-[1] tracking-tightest text-white sm:text-[40px]" data-id="element-37" data-mp="24bk6e9b257rw">
            Preguntas frecuentes.
          </h2>
          <p className="mt-5 max-w-[320px] text-[14px] leading-relaxed text-ink-muted" data-id="element-38" data-mp="1uiv70css7kcx">
            Información general y neutral. Las condiciones definitivas las establece la plataforma.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-39" data-mp="2n5z7c4gxjaid">
          <ul className="border-t border-hairline" data-id="element-40" data-mp="2ryilb2jj47np">
            {faqs.map((faq, index) => {
            const isOpen = open === index;
            return <li key={faq.question} className="border-b border-hairline" data-id="element-41" data-mp="14t7m7evel5y6" data-mpi={index}>
                  <h3 data-id="element-42" data-mp="10v9vg7lzibso">
                    <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-43" data-mp="10rm3ve03nzgl">
                      <span className={`text-[15px] font-medium transition-colors duration-200 ease-smooth ${isOpen ? 'text-brand' : 'text-white'}`} data-id="element-44" data-mp="1jj54je6nj1fg">
                        {faq.question}
                      </span>
                      <PlusIcon className={`h-4 w-4 shrink-0 text-ink-muted transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45 text-brand' : ''}`} aria-hidden="true" data-id="element-45" data-mp="36gkv2ifuc07" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-46" data-mp="286repdamihvo">
                    {isOpen && <motion.div id={`faq-panel-${index}`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-47" data-mp="2c8w2hvee4kae">
                        <p className="max-w-[640px] pb-6 pr-10 text-[14px] leading-relaxed text-ink-muted" data-id="element-48" data-mp="2vw27o8lqf7z9">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}